import { render } from "./SalesPerformance.vue?vue&type=template&id=80a270b8&scoped=true"
import script from "./SalesPerformance.vue?vue&type=script&lang=js"
export * from "./SalesPerformance.vue?vue&type=script&lang=js"

import "./SalesPerformance.vue?vue&type=style&index=0&id=80a270b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a270b8"]])

export default __exports__